import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

// Scope the PMS accounts actions must use instead of the active organization,
// while a screen operates on a scope of its own: a location's integration
// setup works in the LOCATION's scope -- its organization, or the personal
// one when it belongs to none -- whatever the header shows. `null` means no
// override; `{ organizationUid: null }` is the personal scope.
export const PMSScopeOverrideStore = GenericFieldFactory("PMS_SCOPE_OVERRIDE");
